var objImpresionLocalStorage;

function GetImpresionLocalStorage() {
    if (objImpresionLocalStorage == undefined) {
        objImpresionLocalStorage = new ImpresionLocalStorage();
    }
    return objImpresionLocalStorage;
}

function ImpresionLocalStorage() {
    var that = this;

    //-------------------------------------------------------------------------------------------------------------------------
    //DESCRIPCION DE PARÁMETROS 
    //feria: '',
    //verPIM: '',
    //Busqueda: '', busqueda activa
    //pab: '',  pabellón
    //stand: '',
    //codEmpresa: '',
    //numPagina: '',//p - número de página
    //idioma: '',//i - idioma en/es
    //tipoBusqueda: '',//t - cadena de búsqueda: TODO, EMPIEZAPOR,
    //numEmpresas: '',//e - número de empresas
    //textoBusqueda: '',//b - texto de búsqueda
    //subcate: '',//pueden existir dos niveles en las opciones de búsqueda, País > Provincia
    //            //subcate puede ser: 
    //            //c, si la busqueda es en paises
    //            //s, en sectores
    //            //a, actividades
    //            //o, productos
    //            //r, representadas
    //            //m, marcas
    //            //g, si es generico
    //numTotalEmpresas: numero de empresas totales para la última búsqueda
    //menu principal activo, E  - empresas, D - ficha empresa, M - mapa
    //opcionMapa: mapa feria o pabellon activo
    this.setParametros = function () {
        that.objParametros = {
            feria: GetObjConfiguracion().feria,
            verPIM: GetObjConfiguracion().verPIM,
            Busqueda: GetObjConfiguracion().busquedaActiva,
            pab: GetObjConfiguracion().pabellon,
            stand: GetObjConfiguracion().stand,
            Empresa: GetObjConfiguracion().nombreEmpresa,
            numPagina: GetObjConfiguracion().numPagina,
            idioma: GetObjConfiguracion().idio,
            tipoBusqueda: GetObjConfiguracion().tipoBusqueda,
            numEmpresas: GetObjConfiguracion().numEmpresas,
            textoBusqueda: GetObjConfiguracion().textoBusqueda,
            subcate: GetObjConfiguracion().filtroBusquedaActiva,
            numTotalEmpresas: GetObjConfiguracion().numTotalEmpresas,
            menuPrincipalActivo: GetObjConfiguracion().menuPrincipalActivo,
            opcionMapa: GetObjConfiguracion().opMapaActiva,
            txtBusqueda: CatalogoWebUI.criterioElegido(),
            txtFiltroBusqueda: CatalogoWebUI.opcionElegida(),
            MostrarFavoritos: GetFavoritos().MostrarFavoritos,
            MostrarDPostales: GetObjConfiguracion().opDatosPostales,
            recintoPersonalizado: GetObjConfiguracion().EsRecintoPersonalizado(),
            paisId: GetObjConfiguracion().paisId
        };
        $.DSt.set(that.nombreAlmacenImpresion, JSON.stringify(that.objParametros));
    }
    this.getParametros = function () {
        var storedImpresion = $.DSt.get(that.nombreAlmacenImpresion);
        if (storedImpresion != null) {
            that.objParametros = JSON.parse(storedImpresion);
        } else {
            that.objParametros = null;
        }
        //return that.objParametros;
    }
    //-------------------------------------------------------------------------------------------------------------------------
    this.setContadores = function () {
        if (that.objParametros != null) {
            CatalogoWebUI.resultadosPagina(that.objParametros.numTotalEmpresas);
            CatalogoWebUI.numeroEmpresas(that.objParametros.numEmpresas);
        }
    }

    this.LoadFichaEmpresa = function (codEmpresa) {
        $.ajax({
            url: "../waCatalogoWeb/ajax_fichaEmpresa.html",
            success: function (data) {
                $("#contenedorFicha").html(data);
                ko.applyBindings(FichaUI, document.getElementById("contenedorFicha"));
                GetObjConfiguracion().inicializaFichaUI();
                GetObjFichaEmpresa().cargarFichaEmpresa(codEmpresa);
                //FichaUI.setVersionPrint(false);
                FichaUI.mostrarDatosPostales(GetImpresionLocalStorage().objParametros.MostrarDPostales);
            }
        });
    }

    this.componerTextosBusqueda = function () {
        var url = "";
        if (that.objParametros != null) {
            if (that.objParametros.menuPrincipalActivo === "E") {
                if (that.objParametros.Busqueda == "T") {
                    if (that.objParametros.idioma === "es")
                        CatalogoWebUI.criterioElegido("Todas las empresas");
                    else
                        CatalogoWebUI.criterioElegido("All companies");
                }
                else {
                    CatalogoWebUI.criterioElegido(that.objParametros.txtBusqueda);
                    GetObjListaEmpresas().cargarTxtOpcionElegida(that.objParametros.feria, that.objParametros.Busqueda,
                                                                 that.objParametros.idioma, that.objParametros.subcate);
                    //CatalogoWebUI.opcionElegida(that.objParametros.txtFiltroBusqueda.slice(1,that.objParametros.txtFiltroBusqueda.lenght));
                }
            }
            if (that.objParametros.menuPrincipalActivo === "F") {
                if (that.objParametros.idioma === "es")
                    CatalogoWebUI.criterioElegido("Favoritos");
                else
                    CatalogoWebUI.criterioElegido("Favourites");
            }
            if (that.objParametros.menuPrincipalActivo === "D") {
            }
            if (that.objParametros.menuPrincipalActivo === "M") {
            }
        }
    }

    //en base a los parámetros del local storage formamos la url para hacer el get 
    this.componerUrlBusqueda = function (imprimirTodos) {
        var url = "", pagIni, totalEmpresas;
        if (that.objParametros != null) {

            if (imprimirTodos){
                pagIni = 1;
                totalEmpresas = that.objParametros.numTotalEmpresas;
            } else {
                pagIni = that.objParametros.numPagina;
                totalEmpresas = that.objParametros.numEmpresas;
            }

            //marco: yo creo que en algún punto se dijo que se impriman todos los favoritos ....
            //anyway comento esto para que solo imprima lo que se ve
            //if (that.objParametros.verPIM === "S")
            //{
            //    that.objParametros.numPagina = 1;
            //    that.objParametros.numEmpresas = that.objParametros.numTotalEmpresas;
            //}

            //busquedas generales
            if (that.objParametros.menuPrincipalActivo === "E") {
                if (that.objParametros.Busqueda == "T") {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=T&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                                  "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                  "&Tipoindice=T";
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=T&texto=" + that.objParametros.textoBusqueda;
                    }
                }
                if (that.objParametros.Busqueda == "S") {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=S&idindice=" + that.objParametros.subcate + "&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=S&idindice=" + that.objParametros.subcate;
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=S&texto=" + that.objParametros.textoBusqueda +
                            "&idindice=" + that.objParametros.subcate;
                    }
                }
                if (that.objParametros.Busqueda == "P") {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=P&idindice=" + that.objParametros.subcate + "&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=P&idindice=" + that.objParametros.subcate;
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=P&texto=" + that.objParametros.textoBusqueda +
                            "&idindice=" + that.objParametros.subcate;
                    }
                }
                if (that.objParametros.Busqueda == "A") {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=A&idindice=" + that.objParametros.subcate + "&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=A&idindice=" + that.objParametros.subcate;
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=A&texto=" + that.objParametros.textoBusqueda +
                            "&idindice=" + that.objParametros.subcate;
                    }
                }
                if (that.objParametros.Busqueda == "O") {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=O&idindice=" + that.objParametros.subcate + "&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                            "&Tipoindice=O&idindice=" + that.objParametros.subcate;
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=O&texto=" + that.objParametros.textoBusqueda +
                            "&idindice=" + that.objParametros.subcate;
                    }
                }
                if (that.objParametros.Busqueda == "M") {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=M&idindice=" + that.objParametros.subcate + "&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                            "&Tipoindice=M&idindice=" + that.objParametros.subcate;
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=M&texto=" + that.objParametros.textoBusqueda +
                            "&idindice=" + that.objParametros.subcate;
                    }
                }
                if (that.objParametros.Busqueda == "R") {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=R&idindice=" + that.objParametros.subcate + "&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                            "&Tipoindice=R&idindice=" + that.objParametros.subcate;
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=R&texto=" + that.objParametros.textoBusqueda +
                            "&idindice=" + that.objParametros.subcate;
                    }
                }

                var filtroBusqueda = jQuery.inArray(that.objParametros.Busqueda, that.arrayOpcionesBusqueda);
                if (filtroBusqueda == -1) {
                    if (that.objParametros.tipoBusqueda == "TODO") {
                        if (that.objParametros.paisId)
                            url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=" + that.objParametros.Busqueda + "&idindice=" + that.objParametros.subcate + "&PaisId=" + that.objParametros.paisId;
                        else
                            url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                                "&tipoBusqueda=TODO&numero=" + totalEmpresas + "&pagina=" + pagIni +
                                "&Tipoindice=" + that.objParametros.Busqueda + "&idindice=" + that.objParametros.subcate;
                    }
                    else {
                        url = "../wsListaExpositores.svc/GetIndiceEmpresas?Feria=" + that.objParametros.feria +
                            "&tipoBusqueda=" + that.objParametros.tipoBusqueda + "&numero=" + totalEmpresas +
                            "&pagina=" + pagIni + "&Tipoindice=" + that.objParametros.Busqueda + "&texto=" + that.objParametros.textoBusqueda +
                            "&idindice=" + that.objParametros.subcate;
                    }
                }
            }

            //ficha expositor
            if (that.objParametros.menuPrincipalActivo === "D") {

            }
            //favoritos
            if (that.objParametros.menuPrincipalActivo === "F") {
                var listaFavoritos = GetFavoritos().obtenerListaFavoritos();
                if (that.objParametros.idioma == "es") {
                    url = "../wsListaExpositores.svc/GetEmpresasFavoritas?Feria=" + that.objParametros.feria + "&Ids=" + listaFavoritos + "&idioma=es&" +
                        "numero=" + that.objParametros.numEmpresas + "&pagina=" + that.objParametros.numPagina;
                }
                else {
                    url = "../wsListaExpositores.svc/GetEmpresasFavoritas?Feria=" + that.objParametros.feria + "&Ids=" + listaFavoritos + "&idioma=en&" +
                        "numero=" + that.objParametros.numEmpresas + "&pagina=" + that.objParametros.numPagina;
                }
            }
            //mapas
            if (that.objParametros.menuPrincipalActivo === "M") {

            }
        }
        return url;
    }


    //-------------------------------------------------------------------------------------------------------------------------

    

};

ImpresionLocalStorage.prototype = {
    objParametros: '',
    imprimirTodos: false,
    nombreAlmacenImpresion: 'IMPR_',
    arrayOpcionesBusqueda: ["T", "P", "S", "A", "M", "ST", "R", "O", "F", "MAPA"],
}

